import { render, staticRenderFns } from "./admin-order-paymentstatus.vue?vue&type=template&id=db8cbbfe"
import script from "./admin-order-paymentstatus.vue?vue&type=script&lang=js"
export * from "./admin-order-paymentstatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports